import '../../stylesheets/tailwind.css';
